module.exports = __webpack_public_path__ + "media/certificate-install.39856d4c.webm";